import type { IconSvgObject } from './types';

const GravityIcon: IconSvgObject = [
  ["path", { d: "M12 22C15.3137 22 18 19.3137 18 16C18 12.6863 15.3137 10 12 10C8.68629 10 6 12.6863 6 16C6 19.3137 8.68629 22 12 22Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 2V4M17 2V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.0006 2V7.5M12.0006 7.5C12.5005 7.4925 13.135 6.56222 14.0605 5.50277M12.0006 7.5C11.5005 7.4925 11.1849 6.81248 10.0605 5.50277", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default GravityIcon;
